import React from 'react';
import { BuildingIcon, HashIcon, MapPinIcon, DollarSignIcon, UserIcon, CalendarIcon } from 'lucide-react';
import { Loan } from '../types/loan.types';
interface LoanInfoTabProps {
  loan: Loan;
}
export function LoanInfoTab({
  loan
}: LoanInfoTabProps) {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };
  const infoSections = [{
    title: 'Loan Details',
    icon: DollarSignIcon,
    items: [{
      label: 'Loan Amount',
      value: formatCurrency(loan.loanAmount)
    }, {
      label: 'Loan Number',
      value: loan.loanNumber
    }, {
      label: 'Application Date',
      value: 'Jan 5, 2024'
    }, {
      label: 'Loan Type',
      value: 'Conventional 30-Year Fixed'
    }]
  }, {
    title: 'Borrower Information',
    icon: UserIcon,
    items: [{
      label: 'Borrower Name',
      value: loan.borrowerName
    }, {
      label: 'Email',
      value: `${loan.borrowerName.toLowerCase().replace(' ', '.')}@example.com`
    }, {
      label: 'Phone',
      value: '(555) 123-4567'
    }, {
      label: 'Application Status',
      value: 'In Progress'
    }]
  }, {
    title: 'Property Information',
    icon: MapPinIcon,
    items: [{
      label: 'Property Address',
      value: loan.propertyAddress
    }, {
      label: 'Property Type',
      value: 'Single Family Home'
    }, {
      label: 'Purchase Price',
      value: formatCurrency(loan.loanAmount * 1.2)
    }, {
      label: 'Down Payment',
      value: '20%'
    }]
  }, {
    title: 'Brokerage Information',
    icon: BuildingIcon,
    items: [{
      label: 'Brokerage Name',
      value: loan.brokerageName
    }, {
      label: 'Broker Contact',
      value: 'John Smith'
    }, {
      label: 'Broker Email',
      value: 'john.smith@brokerage.com'
    }, {
      label: 'Broker Phone',
      value: '(555) 987-6543'
    }]
  }];
  return <div className="space-y-6" data-id="element-113">
      {infoSections.map(section => {
      const Icon = section.icon;
      return <div key={section.title} className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-114">
            <div className="flex items-center gap-3 mb-4" data-id="element-115">
              <div className="p-2 bg-blue-50 rounded-lg" data-id="element-116">
                <Icon className="w-5 h-5 text-blue-600" data-id="element-117" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900" data-id="element-118">
                {section.title}
              </h3>
            </div>
            <dl className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-119">
              {section.items.map(item => <div key={item.label} data-id="element-120">
                  <dt className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-121">
                    {item.label}
                  </dt>
                  <dd className="mt-1 text-sm font-semibold text-gray-900" data-id="element-122">
                    {item.value}
                  </dd>
                </div>)}
            </dl>
          </div>;
    })}
    </div>;
}